import script from "./SearchBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchBox.vue?vue&type=script&setup=true&lang=js"

import "./SearchBox.vue?vue&type=style&index=0&id=058542ee&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-058542ee"]])

export default __exports__